let productGalleryApi;
let productGalleryTumbsApi;

function product_galleries(){
	if (window.innerWidth < gallery_maxwidth) {
		/* Main Carousel */
		const emblaNode = document.querySelector('.product_carousel')
		const options = { loop: false, inViewThreshold: 0 }
		const plugins = [EmblaCarouselAutoHeight()]
		const productGalleryApi = EmblaCarousel(emblaNode, options, plugins);


		 /* Navigation Arrows */
		const
			emblaPrevButton = emblaNode.querySelector('.embla__prev'),
			emblaNextButton = emblaNode.querySelector('.embla__next'),
			emblaThumbs = document.querySelectorAll('.product_carousel-thumbs .product_carousel__slide');

		function logSlidesInView(selectedIndex,lastIndex) {

			emblaThumbs.forEach(otherThumb => {
				otherThumb.classList.remove('selected-thumb');
			});

			const emblaNewThumb = document.querySelector('#thumb-slide-'+selectedIndex);
			emblaNewThumb.classList.add('selected-thumb');

			if (emblaNextButton) {
				if ( selectedIndex >= lastIndex) {
					emblaNextButton.setAttribute('disabled', 'true');
				} else {
					emblaNextButton.removeAttribute('disabled');
				}

				if ( selectedIndex == 0) {
					emblaPrevButton.setAttribute('disabled', 'true');
				} else {
					emblaPrevButton.removeAttribute('disabled');
				}
			}
		}

		productGalleryApi.on('select', () => {
			const selectedIndex = productGalleryApi.selectedScrollSnap();
			const lastIndex = productGalleryApi.scrollSnapList().length - 1;
			//console.log(selectedIndex);
			logSlidesInView(selectedIndex,lastIndex)
		});

		/* Thumbnail Carousel */
		const emblaTumbsNode = document.querySelector('.product_carousel-thumbs')
		const Tumbsoptions = { loop: false, align: "start", skipSnaps: true }

		if ( emblaTumbsNode ) {
			productGalleryTumbsApi = EmblaCarousel(emblaTumbsNode, Tumbsoptions);
		}

		const productThumbsContainer = document.querySelector('.product_carousel-thumbs');

		if (emblaNextButton) {
			emblaPrevButton.addEventListener('click', productGalleryApi.scrollPrev, false);
			emblaNextButton.addEventListener('click', productGalleryApi.scrollNext, false);
		}

		// Add event listeners for navigation pagination
		if (emblaThumbs) {
			emblaThumbs.forEach((pagination) => {
				pagination.addEventListener('click', (event) => {
					const slideIndex = parseInt(pagination.getAttribute('data-slide'), 10);
					//console.log(slideIndex);
					if (!isNaN(slideIndex)) {
							productGalleryApi.scrollTo(slideIndex); // Scroll to the slide index
					}
				});
			});
		}
	}
}
product_galleries();


document.addEventListener('DOMContentLoaded', function () {

	const
		optionRadios = document.querySelectorAll('.product-option-radio'),
		selectedVariantIdInput = document.querySelector('.selected-variant-id'),
		productPrice = document.querySelector('.product-price'),
		productComparePrice = document.querySelector('.compare-at-price'),
		productCta = document.querySelector('#product-cta');

	function updateSelectedVariant() {
		const selectedOptions = {};
		optionRadios.forEach(radio => {
			if (radio.checked) {
				selectedOptions[`option${radio.dataset.optionIndex}`] = radio.value;

				const product_option_obj = radio.closest('.product-options').querySelector('legend span');
				if (product_option_obj) {
					product_option_obj.innerHTML = radio.value;
				}
			}
		});

		//Check each option to see if the matching variant exists and is available
		optionRadios.forEach(radio => {
			const optionName = radio.getAttribute('name').replace('-', '');
			let OptionOptions = { ...selectedOptions };

			if (optionName in OptionOptions) {
				OptionOptions[optionName] = radio.value;
			}

			const matchingVariant = product_variants.find(variant => {
				return Object.keys(OptionOptions).every(optionName => {
					return variant[optionName] === OptionOptions[optionName];
				});
			});

			if (matchingVariant && matchingVariant.available) {
				radio.nextElementSibling.style.display = "flex"
			} else {
					if (radio.nextElementSibling && radio.nextElementSibling.classList.contains('option-type-frame')) {
				radio.nextElementSibling.style.display = "none"
				}
			}
		});

		const selectedVariant = product_variants.find(variant => {
			return Object.keys(selectedOptions).every(optionName => {
				return variant[optionName] === selectedOptions[optionName];
			});
		});

		if (selectedVariant) {
			selectedVariantIdInput.value = selectedVariant.id;
			updateProductUrl(selectedVariant.id);

			fetch(window.location.href+'&sections='+section_id)
			.then(response => response.text())
			.then(html => {
				parsedHTML = JSON.parse(html)
				const parsedSection = parsedHTML[section_id]
				const parser = new DOMParser();
				const sectionHTML = parser.parseFromString(parsedSection, 'text/html');

				const sections_to_update = [
					"#product-cta",
					"#product-orientation",
					"#product-prices",
					"#product-gallery",
					"#frame-external-dimension",
					"#the-frame-content"
				]

				if (window.innerWidth < 767) {
					if (productGalleryApi) {
						productGalleryApi.destroy();
					}
					if (productGalleryTumbsApi) {
						productGalleryTumbsApi.destroy();
					}
				}

				sections_to_update.forEach(update_id => {
					//console.log( document.querySelector(update_id) );
					//console.log(sectionHTML );
					if (document.querySelector(update_id)) {
						document.querySelector(update_id).innerHTML = sectionHTML.querySelector(update_id).innerHTML;
					}
				});

				product_galleries();
				init_videos();

				const product_qr = sectionHTML.querySelector('#product-qr')
				if (product_qr) {
					const product_qr = sectionHTML.querySelector('#product-qr')
					document.querySelector('#product-qr').innerHTML = product_qr.innerHTML;
					const qr_width = product_qr.getAttribute('data-width');
					const qr_height = product_qr.getAttribute('data-height');
					var qrcode = new QRCode(document.getElementById('qrcode'), {
						text: `https://size.link?l=`+qr_width+`&h=`+qr_height+`&w=3&units=cm`,
						width: 256,
						height: 256,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H,
					});
				}
			})
			.catch(e => {
				console.error(e);
			});
		} else {
			const productCtaButton = productCta.querySelector('a');

			if (productCtaButton) {
					productCtaButton.classList.add('disabled');
			}

			const option_type_frame_style = document.querySelector('#option-type-frame-style');
			if ( option_type_frame_style ){
				option_type_frame_style.querySelector('legend span').innerHTML = 'Choose a style'
			}
		}
	}

	function updateProductUrl(variantId) {
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('variant', variantId);
		window.history.replaceState({}, '', currentUrl);
	}

	// Initialize form submit handler once
	const productForm = document.querySelector('.product-form');
	if (productForm) {
		productForm.addEventListener('submit', (event) => {
			event.preventDefault();
			const selectedVariantId = selectedVariantIdInput.value;
			if (selectedVariantId) {

				let form_properties = {};
				const inputProperties = productForm.querySelectorAll('[name*="properties"]');

				inputProperties.forEach(input => {
					let nameValue = input.name;
					nameValue = nameValue.replace('properties[', '').replace(']', '');

					if ((input.type === "text" || input.type === "email" || input.tagName.toLowerCase() === "textarea") && input.value.trim() !== "" ) {
						form_properties[nameValue] = input.value
					}
					if (input.type === "radio" && input.checked){
						form_properties[nameValue] = input.value;
					}
					if (input.type === "checkbox" && input.checked){
						if (input.id === "recipient-checkbox") {
							form_properties[nameValue] = true
						} else {
							form_properties[nameValue] = input.value
						}
					}
					if ( input.type === "date"){
						form_properties[nameValue] = input.value
					}
				});

				let product_data = {
					quantity:1,
					id: selectedVariantId
				}
				if (form_properties && form_properties != {} ) {
					product_data = {
						quantity:1,
						id: selectedVariantId,
						properties: form_properties
					}
				}

				fetch('/cart/add.js', {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					},
					body: JSON.stringify(product_data)
				}).then((response) => {
					return new Promise((resolve) => response.json()
					.then((json) => resolve({
							status: response.status,
							ok: response.ok,
							json,
					})));
				}).then(({ status, json, ok }) => {
					switch (status) {
						case 400:
								console.log('no product available');
								break;
						case 201:
								break;
						case 200:
								console.log("added: " + selectedVariantId );
								window.location.href = '/cart';
								break;
						case 500:
								break;
						default:
						//Any default tasks
					}
				})
			}
		});
	}

	optionRadios.forEach(radio => {
		radio.addEventListener('change', updateSelectedVariant);
	});

	const url = new URL(window.location.href);
	if (url.searchParams.has('variant')) {
		//variant already selected
	} else {
		updateSelectedVariant();
	}


	/* Gift Cards */
	const
		recipientCheckbox = document.getElementById('recipient-checkbox'),
		giftcardRecipient = document.querySelector('.giftcard-recipient'),
		giftcardDate = document.getElementById('Recipient-send-on-date');

	// Get the current date
	const today = new Date();

	// Format it into YYYY-MM-DD (required format for date inputs)
	const year = today.getFullYear();
	let month = today.getMonth() + 1; // JavaScript months are 0-indexed
	let day = today.getDate();

	// Add leading zeros if necessary
	if (month < 10) { month = '0' + month; }
	if (day < 10) { day = '0' + day; }

	const formattedDate = `${year}-${month}-${day}`;

	if (recipientCheckbox) {
		recipientCheckbox.addEventListener('change', function() {
			if (this.checked) {
				giftcardRecipient.classList.remove('hidden');
				giftcardDate.value = formattedDate;
				giftcardDate.min = formattedDate;
			} else {
				giftcardRecipient.classList.add('hidden');
				giftcardDate.value = '';
				giftcardDate.min = '';
			}
		});
	}

	//Characters left function
	function gc_msg_update(thisInput) {
		if (event.which !== 13) { // Check if the pressed key is not Enter
			document.getElementById('gc-char-left').textContent = 200 - thisInput.value.length;
		}
	}
	const gc_message = document.getElementById('message');
	if (gc_message){
		gc_message.addEventListener('input', function (event) {
			gc_msg_update(this);
		});
	}

});